import api from '../../utils/api';

const API_BASE_URL = "/admin/ADPTabaudit"; // Adjust to match your backend API

const ADPTabauditService = {
    async findAll(facilityCode: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all`, { params: { facilityCode } });
        return response.data;
    },

    async getItemById(tableName: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one/${tableName}`);
        return response.data;
    },

    async create(user: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/create`, user);
        return response.data;
    },

    async update(tableName: string, user: any): Promise<any> {
        const response = await api.put(`${API_BASE_URL}/update/${tableName}`, user);
        return response.data;
    },

    async delete(tableName: string): Promise<any> {
        const response = await api.delete(`${API_BASE_URL}/delete/${tableName}`);
        return response.data;
    },

    async getDropdown(): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/get-dropdown`);
        return response.data;
    }
};



export default ADPTabauditService;